import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DeliveriesFilters } from 'src/app/components/massive/models/deliveriesFilters.model';
import { ItemNumberToFilterShared } from 'src/app/components/shared/models/interface/itemNumberToFilter.interface';
import { FiltersToolbarAccessor } from 'src/app/components/shared/sharedModules/designSystem/models/filtersToolbarAccessor.interface';
import { MuFilterToolbarComponent } from 'src/app/components/shared/sharedModules/designSystem/mu-filter-toolbar/mu-filter-toolbar.component';
import { FilterField } from 'src/app/components/shared/types/filterField.type';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MassiveServiceFlags } from '../../massive-services.flags';

@Component({
  selector: 'app-deliveries-filters-toolbar',
  templateUrl: './deliveries-filters-toolbar.component.html',
  styleUrls: ['./deliveries-filters-toolbar.component.sass']
})
export class DeliveriesFiltersToolbarComponent  implements OnInit, FiltersToolbarAccessor<DeliveriesFilters, MassiveServiceFlags> {
  /**
   * Service flags
   */
  massiveServiceFlags = MassiveServiceFlags;
  /**
   * Input flags list
   */
  @Input() flagList: Flags<MassiveServiceFlags>;
  /**
   * Input filters list
   */
  @Input() filterList: Filters<DeliveriesFilters>;
  /**
   * Input filter field list
   */
  @Input() filterFieldList: FilterField<DeliveriesFilters>[];
  /**
   * Input locality list
   */
  @Input() localityList: ItemNumberToFilterShared[];
  /**
   * Input weight list
   */
  @Input() weightList: ItemNumberToFilterShared[];

  @ViewChild(MuFilterToolbarComponent) filterToolbar;
  options: ItemNumberToFilterShared[];
  minDateEstimate: Date;
  minDateCreate: Date;
  maxDateCreate: Date;

  ngOnInit(): void {
    this.minDateEstimate = new Date();
    this.minDateCreate = new Date();
    this.maxDateCreate = new Date();
    this.maxDateCreate.setDate(this.maxDateCreate.getDate());
  }

  /**
   * set dates and return filterToolbar
   * @param {Number} optionId
   */
  getFilterToolBar(): MuFilterToolbarComponent<DeliveriesFilters, MassiveServiceFlags> {
    this.maxDateCreate.setDate(this.maxDateCreate.getDate());
    if (this.filterToolbar.filterList?.filtersData?.estimateDateStart) {
      this.minDateEstimate = this.filterToolbar.filterList.filtersData?.estimateDateStart;
    }
    if (this.filterToolbar.filterList?.filtersData?.createDateStart) {
      this.minDateCreate = this.filterToolbar.filterList.filtersData?.createDateStart;
    }
    return this.filterToolbar;
  }


  /**
   * get the label string for an id
   * @param {Number} optionId
   */
  getLabelById(optionId: number): string {
    if (optionId === null || optionId === undefined || !this.options) {
      return '';
    }
    return this.options.find(r => r.value === optionId)?.label || '';
  }

  /**
   * update date min estimate
   * @param {Date} date
   */
  changeDateMinEstimate(date: Date): void {
    if (date) {
      this.minDateEstimate = date;
    }
  }

  /**
   * update date min create
   * @param {Date} date
   */
  changeDateMinCreate(date: Date): void {
    if (date) {
      this.minDateCreate = date;
    }
  }
}
